module.exports = __webpack_public_path__ + "img/cross-middle-image.95029b33.webp";